import '../styles/techIcon.css'

function TechIcon({icon}) {
  return (
    <div className="techIcon">
      <img src={icon} alt='technology'/>
    </div>
  )
}

export default TechIcon
